/* import __COLOCATED_TEMPLATE__ from './attribute-row.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();